import {
  ThemeToggleButton,
  LanguageToggleButton,
} from "@/ui/components/common";
import { NavLinks } from "./NavLinks";
import { UserMenu } from "./UserMenu";

interface MobileMenuProps {
  isOpen: boolean;
  onClose: () => void;
}

/**
 * 移動端選單組件
 * 顯示在移動裝置上的導航選單
 */
export function MobileMenu({ isOpen, onClose }: MobileMenuProps) {
  if (!isOpen) return null;

  return (
    <div className="sm:hidden">
      {/* 導航連結 */}
      <div className="pt-2 pb-3 space-y-1 px-4">
        <NavLinks isMobile onItemClick={onClose} />
      </div>

      {/* 移動端選單底部 */}
      <div className="pt-4 pb-3 border-t border-gray-200 dark:border-gray-700">
        {/* 用戶信息 */}
        <UserMenu isMobile />

        {/* 功能按鈕 */}
        <div className="mt-4 flex items-center justify-center space-x-6 px-4">
          <ThemeToggleButton />
          <LanguageToggleButton />
        </div>
      </div>
    </div>
  );
}
